/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-07-29",
    versionChannel: "nightly",
    buildDate: "2023-07-29T00:19:39.173Z",
    commitHash: "82b88ebff59f7992eeb4d10a18dec28d8714d338",
};
